import TrackingService from 'app/services/tracking/tracking.service';
import TagsService from "external-services/tags-service";

const NS = 'TagEditorCtrl';

export default function TagEditorCtrl(
    $log, $scope, $mdDialog, $filter, tag, highestOrder
) {
    "ngInject";

    const vm = this;

    //-- define public properties
    vm.title = 'New Tag';
    // states
    vm.LOADING = 1;
    vm.ENTER = 0;
    vm.SUCCESS = 2;
    vm.ERROR = 3;
    vm.state = vm.ENTER;
    //-- define public methods
    vm.cancel = cancel;
    vm.save = save;

    $scope.$watch('tagEditorCtrl.tagIconId', updateIcon);

    checkEdit();
    getTagTypes();

    if (tag) {
        TrackingService.trackPageView('settings.tags.edit');
    } else {
        TrackingService.trackPageView('settings.tags.new');
    }

    function checkEdit() {
        if (tag) {
            vm.title = 'Edit Tag';
            vm.name = tag.name;
            vm.online = tag.online;
            vm.permanent = tag.permanent;
        }
    }

    function updateIcon() {
        if (vm.tagIcons) {
            for (var i = vm.tagIcons.length - 1; i >= 0; i--) {
                var icon = vm.tagIcons[i];
                if (vm.tagIconId === icon._id) {
                    vm.icon = icon;
                }
            }
        }
    }

    function getTagTypes() {
        TagsService.getTagTypes().then(function (tagtypes) {
            if (tag) {
                for (var i = tagtypes.length - 1; i >= 0; i--) {
                    var tagtype = tagtypes[i];
                    if (tagtype._id === tag.tagtype._id) {
                        vm.tagtypeId = i;
                    }
                }
            }
            vm.tagtypes = tagtypes;
            getTagIcons();
        }).catch(function (err) {
            console.warn('getTagTypes', err);
            $log.error('Tag types failed to load');
        });
    }

    function getTagIcons() {
        TagsService.getTagIcons().then(function (tagIcons) {
            vm.tagIcons = $filter('orderBy')(tagIcons, 'name');
            for (var i = tagIcons.length - 1; i >= 0; i--) {
                var icon = tagIcons[i];
                icon._id = 'tag_' + i;
                if (tag) {
                    if (icon.icon === tag.icon) {
                        vm.tagIconId = icon._id;
                        vm.icon = icon;
                    }
                }
            }
            vm.tagColours = TagsService.tagColours;
            vm.tagColour = vm.tagColours[0].value;
            if (tag && tag.colour) {
                vm.tagColour = tag.colour;
            }
        }).catch(function (err) {
            $log.error('Tag icons failed to load');
        });
    }

    function cancel() {
        $mdDialog.hide();
    }

    function save(isValid) {
        if (isValid) {
            vm.state = vm.LOADING;
            if (tag) {
                tag.name = vm.name;
                tag.tagtype = vm.tagtypes[vm.tagtypeId];
                tag.icon = vm.icon.icon;
                tag.online = vm.online;
                tag.permanent = vm.permanent;
                tag.colour = vm.tagColour;
                // update
                TagsService.updateTag(tag).then(function () {
                    vm.state = vm.SUCCESS;
                    $mdDialog.hide();
                }).catch(function () {
                    vm.state = vm.ENTER;
                });
            } else {
                var order = highestOrder + 1;
                // add
                var newTag = {};
                newTag.name = vm.name;
                newTag.tagtype = vm.tagtypes[vm.tagtypeId];
                newTag.icon = vm.icon.icon;
                newTag.online = vm.online;
                newTag.permanent = vm.permanent;
                newTag.colour = vm.tagColour;
                newTag.order = order;
                TagsService.addTag(newTag).then(function () {
                    vm.state = vm.SUCCESS;
                    $mdDialog.hide();
                }).catch(function () {
                    vm.state = vm.ENTER;
                });
            }
        } else {
            vm.displayErrors = true;
        }
    }
}
